module.exports = __webpack_public_path__ + "static/img/h6-1.8965f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h6-1.png
// module id = fsaA
// module chunks = 1